import React from 'react';
import { emojiMapStyling } from './style';
import { StyleSheet, View } from 'react-native';
import { emojiSubIcon } from '../../../containers/OnlineReview/components/OnlineReviewComp/components/SentimentChart/utils';

const OtaIcon = ({ source }) => {
  const styles = emojiMapStyling();
  return <View style={styles.container}>{emojiSubIcon(source,StyleSheet.flatten(styles.iconStyle))}</View>;
};

export default OtaIcon;
